import apiClient from '../apiClient';

export async function putClientSetting(clientId: number): Promise<void> {
  return apiClient<void>(`user/SelectedClientId?clientId=${clientId}`, {
    method: 'Put',
  });
}   